// /src/pages/publicTab/PolicyTab.jsx

import React from 'react';
import PublicLexicalPage from '../../components/PublicLexicalPage';

function PolicyTab({ onTocReady, onTocVisibleChange }) {
  return (
    <PublicLexicalPage 
      documentName="Policy"
      layout="plain"
      onTocReady={onTocReady}
      onTocVisibleChange={onTocVisibleChange}
    />
  );
}

export default PolicyTab;